<div class="h-100 w-100">
  <app-graph></app-graph>
</div>
